// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"LearnPrayingPrivacyPolicy_contentContainer__26nmN","title":"LearnPrayingPrivacyPolicy_title__1oqax","subtitle":"LearnPrayingPrivacyPolicy_subtitle__31ynW"};